import axios from "axios";
let cancel;

export default class CouponService {
    _apiBase = '/ajax/fast-order/coupon.php';

    constructor() {
        this.cancel = null;
    }

    getResource = async (params) => {
        if (cancel != undefined) {
            cancel();
        }

        return await axios.post(this._apiBase, params,{
            cancelToken: new axios.CancelToken(function executor(c) {
                cancel = c;
            })
        }).then(value => {
            return value.data;
        }).catch(() => {
            return [];
        });
    };

    checkCoupon = async (item, coupon) => {
        return await this.getResource({
            item,
            coupon,
        });
    };
}